// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608212007/js/" + chunkId + "." + {"44":"dca7c247","225":"b5bd961b","481":"307f0825","486":"488200c8","770":"0b0c9b1a"}[chunkId] + ".0.759574138642653.chunk.js";
};